import { BaseModel } from '../../../../../../core/_base/crud';
export class PhieuKiemKe extends BaseModel {
	IdKk: number
	Sophieu: string
	Nguoikk: number
	Ngaykk: string
	Ngaytao: string
	Nguoitao: number
	TenNguoitao: string
	Tinhtrang: string
	TenTinhTrang: string
	IdKho: number
	TenKho : string
	Thukhoxacnhan: number
	TenThukhoxacnhan: string
	Ngayxacnhan: string
	Diengiai: string
	IdNk: number
	IdXk: number
	SoPhieuNhapKho: string
	SoPhieuXuatKho :string
	listNguoiThucHien: NguoiThucHienKiemKe[]
	listChiTietKhoKiemkekho: ChiTietPhieuKiemKe[]
	IsEnable_Duyet: boolean
	IsVisible_Duyet: boolean
	IsNotdirector:boolean
	static search = [
		{objCode : "MaHH", 		objKey : "MaHH",			objValue : "Mã hàng"},
		{objCode : "TenHH", 	objKey : "TenHH",			objValue : "Tên hàng"},
		{objCode : "SoLo", 	objKey : "SoLo",			objValue : "Số lô"},
		{objCode : "ViTriKho", 	objKey : "ViTriKho",			objValue : "Vị trí kho"},

	]
	clear() {
		this.IdKk = 0;
		this.Sophieu = '';
		this.Ngaykk = '';
		this.Nguoikk = 0;
		this.Ngaytao = '';
		this.Nguoitao = 0;
		this.TenNguoitao = '';
		this.Tinhtrang = 'KK_DANGSOANTHAO';
		this.TenTinhTrang = 'Đang soạn thảo';
		this.IdKho = 0;
		this.TenKho = '';
		this.Thukhoxacnhan = 0;
		this.TenThukhoxacnhan = '';
		this.Ngayxacnhan = '';
		this.Diengiai = '';
		this.listNguoiThucHien = [];
		this.listChiTietKhoKiemkekho = [];
		this.IsEnable_Duyet = false;
		this.IsVisible_Duyet = false;
		this.IsNotdirector=false;
		this.IdXk = 0;
		this.IdNk = 0;
		this.SoPhieuNhapKho = ""
		this.SoPhieuXuatKho = ""
	}
	copy(item: PhieuKiemKe) {
		this.IdKk = item.IdKk;
		this.Sophieu = item.Sophieu;
		this.Ngaykk = item.Ngaykk;
		this.Nguoikk = item.Nguoikk;
		this.Ngaytao = item.Ngaytao;
		this.Nguoitao = item.Nguoitao;
		this.TenNguoitao = item.TenNguoitao;
		this.Tinhtrang = item.Tinhtrang;
		this.TenTinhTrang = item.TenTinhTrang;
		this.IdKho = item.IdKho;
		this.TenKho = item.TenKho;
		this.Thukhoxacnhan = item.Thukhoxacnhan;
		this.TenThukhoxacnhan = item.TenThukhoxacnhan;
		this.Ngayxacnhan = item.Ngayxacnhan;
		this.Diengiai = item.Diengiai;
		this.listNguoiThucHien = item.listNguoiThucHien;
		this.listChiTietKhoKiemkekho = item.listChiTietKhoKiemkekho;
		this.IsEnable_Duyet = item.IsEnable_Duyet;
		this.IsVisible_Duyet = item.IsVisible_Duyet;
		this.IsNotdirector=false;
		this.IdXk = item.IdXk;
		this.IdNk = item.IdNk;
		this.SoPhieuNhapKho = item.SoPhieuNhapKho;
		this.SoPhieuXuatKho = item.SoPhieuXuatKho
	}
}
export class ChiTietPhieuKiemKe extends BaseModel {
	IdCtkk: number
	IdKk: number
	IdHh: number
	TenHH: string
	MaHH: string
	QuyCach: string
	Dvt: number
	TenDVT: string
	IdKho: number
	TenKho: string
	MaKho: string
	ViTriKho: string
	IdLo: string
	Solo: string
	Sopo: string
	Tinhtrang: boolean
	Soluongphanmem: number
	Soluongthucte: number
	Soluonghientai: number
	Chenhlech: number
	isError: boolean
	isWarning: boolean
	messageError: string
	DaXacNhanSoLuong:boolean
	LyDoChenhLech:string
	HuongXuLy:string
	SoMay: string
	SoMeSoXe :string
	MaThung: string
	Ghichu: string
	MaSub: string
	NgayNhap: string
	ChoPhepXuatKho: boolean
	FlagNK : boolean
	listDVTInfo: any[]
	IdTk: number
	MaPallet : string
	clear() {
		this.IdCtkk = 0;
		this.IdKk = 0;
		this.IdHh = 0;
		this.TenHH = '';
		this.MaHH = '';
		this.QuyCach = '';
		this.Dvt = 0;
		this.TenDVT = '';
		this.IdKho = 0;
		this.TenKho = '';
		this.MaKho = '';
		this.Tinhtrang = true;
		this.Soluongphanmem = 0.00;
		this.Soluongthucte = 0.00;
		this.Chenhlech = 0.00;
		this.ViTriKho = '';
		this.IdLo = '';
		this.Solo = '';
		this.Sopo = '';
		this.isError = false;
		this.isWarning = false;
		this.messageError = '';
		this.DaXacNhanSoLuong=false;
		this.LyDoChenhLech='';
		this.HuongXuLy='';
		this.SoMay = '';
		this.MaSub = '';
		this.NgayNhap = '';
		this.ChoPhepXuatKho = false;
		this.FlagNK = false;
		this.MaThung = '';
		this.SoMeSoXe = '';
		this.Ghichu = '';
		this.IdTk = 0;
		this.MaPallet = '';
		this.Soluonghientai = 0;
	}
	copy(item: ChiTietPhieuKiemKe) {
		this.IdCtkk = item.IdCtkk;
		this.IdKk = item.IdKk;
		this.IdHh = item.IdHh;
		this.TenHH = item.TenHH;
		this.MaHH = item.MaHH;
		this.QuyCach = item.QuyCach;
		this.Dvt = item.Dvt;
		this.TenDVT = item.TenDVT;
		this.IdKho = item.IdKho;
		this.TenKho = item.TenKho;
		this.MaKho = item.MaKho;
		this.Tinhtrang = item.Tinhtrang;
		this.Soluongphanmem = item.Soluongphanmem;
		this.Soluongthucte = item.Soluongthucte;
		this.Chenhlech = item.Chenhlech;
		this.ViTriKho = item.ViTriKho;
		this.IdLo = item.IdLo;
		this.Sopo = item.Sopo;
		this.Solo = item.Solo;
		this.isError = item.isError;
		this.isWarning = item.isWarning;
		this.messageError = item.messageError;
		this.DaXacNhanSoLuong=item.DaXacNhanSoLuong;
		this.LyDoChenhLech=item.LyDoChenhLech;
		this.HuongXuLy=item.HuongXuLy;
		this.SoMay = item.SoMay;
		this.MaSub = item.MaSub;
		this.NgayNhap = item.NgayNhap;
		this.ChoPhepXuatKho = item.ChoPhepXuatKho;
		this.FlagNK = item.FlagNK;
		this.MaThung = item.MaThung;
		this.SoMeSoXe = item.SoMeSoXe;
		this.Ghichu = item.Ghichu;
		this.IdTk = item.IdTk;
		this.MaPallet = item.MaPallet
		this.Soluonghientai = item.Soluonghientai
	}
}
export class NguoiThucHienKiemKe extends BaseModel {
	IdKk: number
	NguoiThucHien: number
	TenNguoiThucHien: string

	clear() {
		this.IdKk = 0;
		this.NguoiThucHien = 0;
		this.TenNguoiThucHien = '';
	}

	copy(item: NguoiThucHienKiemKe) {
		this.IdKk = item.IdKk;
		this.NguoiThucHien = item.NguoiThucHien;
		this.TenNguoiThucHien = item.TenNguoiThucHien;
	}
}
